import axios from 'axios'
import Qs from 'qs';
import config from '../apiConfig'
import url from '../baseUrl'

let baseUrl = url.salaryUrl

function randomNum(minNum, maxNum) {
  return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
}

const $handleToExcel = (res) => {
  console.log(1000)
  console.log(res)
  let blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel'
  });
  let fileName = Date.parse(new Date()) + randomNum(1, 1200) + '.xlsx'
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName)
  } else {
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    link.click()
    //释放内存
    window.URL.revokeObjectURL(link.href)
  }
}

const addFile = baseUrl + "/storage/addFile?createAccount=";
const $ajaxAddFile = params => axios.post(baseUrl + '/storage/addFile', params);
//查询仓库列表 /wmshouse/getPageList
const $axiosGetWmshousePageList = params => axios.get(baseUrl + '/wmshouse/getPageList', {params});
// 添加仓库，添加人id名字都传 /jzworkerapiservice/wmshouse/add
const $axiosWmshouseAdd = params => axios.post(baseUrl + '/wmshouse/add', params);
// 1启用 2停用 仓库 /jzworkerapiservice wmshouse/updateStatus
const $axiosUpdateStatus = params => axios.get(baseUrl + '/wmshouse/updateStatus', {params});
// 修改仓库，修改人id名字都传  /jzworkerapiservice/wmshouse/add
const $axiosWmshouseUpdate = params => axios.post(baseUrl + '/wmshouse/update', params);
//查询仓库下拉框,可不传sysUserId /wmshouse/getAllHouse
const $axiosgetAllHouse = params => axios.get(baseUrl + '/wmshouse/getAllHouse', {params});
//根据当前登录人查询用户管理的有效仓库  /jzworkerapiservice/wmshouse/geCurrentLoginUserHouse
const $axiosGeCurrentLoginUserHouse = params => axios.get(baseUrl + '/wmshouse/geCurrentLoginUserHouse', {params});
//查询我的仓库列表 库存 /wmsHouseStock/stockList
const $axiosWmsHouseStockStockList = params => axios.post(baseUrl + '/wmsHouseStock/stockList', params);
//子库存详情，仓库id，商品sku 库存 /wmsHouseStock/stockSubInfo
const $axiosWmsHouseStockstockSubInfo = params => axios.get(baseUrl + '/wmsHouseStock/stockSubInfo', {params});
//查询出入库记录列表 /wmsHouseStock/getStockLogPage
const $axiosWmsHouseStockgetStockLogPage = params => axios.post(baseUrl + '/wmsHouseStock/getStockLogPage', params);
//库存统计 /wmsHouseStock/getStockReport
const $axiosWmsHouseStockgetStockReport = params => axios.post(baseUrl + '/wmsHouseStock/getStockReport', params);
//获取所有城市服务站cityStation/getAllStationList
const $axiosGetAllStationList = params => axios.get(baseUrl + '/cityStation/getAllStationList', {params});
//获取所有城市服务站cityStation/getall
const $axiosCityStationGetAll = params => axios.get(baseUrl + '/cityStation/getall', {params});
//获取所有城市getallCity
const $axiosgetallCity = params => axios.get(baseUrl + '/cityStation/getallCity', {params});
// 查询出入库订单列表  /jzworkerapiservice/wmsStockOrder/getStockOrderList
const $axiosGetStockOrderList = params => axios.post(baseUrl + '/wmsStockOrder/getStockOrderList', params);
// 出入库订单商品详情  /jzworkerapiservice/wmsStockOrder/getStockOrderInfo
const $axiosGetStockOrderInfo = params => axios.get(baseUrl + '/wmsStockOrder/getStockOrderInfo', {params});
// 操作出入库单 /jzworkerapiservice/wmsStockOrder/operateStockOrder
const $axiosOperateStockOrder = params => axios.get(baseUrl + '/wmsStockOrder/operateStockOrder', {params});
// 查询整个类目树/jzworkerapiservice/wmsCategory/categoryTree
const $axiosCategoryTree = params => axios.get(baseUrl + '/wmsCategory/categoryTree', {params});
//  添加类目/jzworkerapiservice/wmsCategory/addNewCategory
const $axiosAddNewCategory = params => axios.get(baseUrl + '/wmsCategory/addNewCategory', {params});
//  删除类目节点/jzworkerapiservice/wmsCategory/deleteCategory
const $axiosDeleteCategory = params => axios.get(baseUrl + '/wmsCategory/deleteCategory', {params});
// 更新类目节点信息 /jzworkerapiservice/wmsCategory/updateCategory
const $axiosUpdateCategory = params => axios.post(baseUrl + '/wmsCategory/updateCategory', params);
//  查看品牌列表 /jzworkerapiservice/wmsBrand/brandList
const $axiosBrandList = params => axios.get(baseUrl + '/wmsBrand/brandList', {params});
//启用品牌商  /jzworkerapiservice/wmsBrand/ableBrand
const $axiosAbleBrand = params => axios.get(baseUrl + '/wmsBrand/ableBrand', {params});
//停用品牌商  /jzworkerapiservice/wmsBrand/disabledBrand
const $axiosDisabledBrand = params => axios.get(baseUrl + '/wmsBrand/disabledBrand', {params});
//添加品牌商  /jzworkerapiservice/wmsBrand/addNewBrand
const $axiosAddNewBrand = params => axios.post(baseUrl + '/wmsBrand/addNewBrand', params);
//修改品牌商信息  /jzworkerapiservice/wmsBrand/modifyBrand
const $axiosModifyBrand = params => axios.post(baseUrl + '/wmsBrand/modifyBrand', params);
//  查询属性列表 /jzworkerapiservice/wmsProperty/propertyList
const $axiosPropertyList = params => axios.get(baseUrl + '/wmsProperty/propertyList', {params});
//  删除属性 /jzworkerapiservice/wmsProperty/deleteProperty
const $axiosDeleteProperty = params => axios.get(baseUrl + '/wmsProperty/deleteProperty', {params});
//  添加属性 /jzworkerapiservice/wmsProperty/addNewProperties
const $axiosAddNewProperties = params => axios.get(baseUrl + '/wmsProperty/addNewProperties', {params});
//修改属性  /jzworkerapiservice/wmsProperty/updateProperty
const $axiosUpdateProperty = params => axios.post(baseUrl + '/wmsProperty/updateProperty', params);
//  查看某个类目绑定的属性 /jzworkerapiservice/wmsPropertyBind/propertyBindRelationByCategoryId
const $axiosPropertyBindRelationByCategoryId = params => axios.get(baseUrl + '/wmsPropertyBind/propertyBindRelationByCategoryId', {params});
//  绑定属性到类 /jzworkerapiservice/wmsPropertyBind/bindProperty
const $axiosBindProperty = params => axios.get(baseUrl + '/wmsPropertyBind/bindProperty', {params});
//  删除属性绑定关系 /jzworkerapiservice/wmsPropertyBind/deletePropertyBindRelation
const $axiosDeletePropertyBindRelation = params => axios.get(baseUrl + '/wmsPropertyBind/deletePropertyBindRelation', {params});
//修改属性绑定  /jzworkerapiservice/wmsPropertyBind/modifyPropertyBind
const $axiosModifyPropertyBind = params => axios.post(baseUrl + '/wmsPropertyBind/modifyPropertyBind', params);
// 查询商品列表 /jzworkerapiservice/WmsCommodity/commodityList
const $axiosCommodityList = params => axios.get(baseUrl + '/WmsCommodity/commodityList', {params});
// 上架商品 /jzworkerapiservice/WmsCommodity/ableCommodity
const $axiosAbleCommodity = params => axios.get(baseUrl + '/WmsCommodity/ableCommodity', {params});
//上传商品图片 /jzworkerapiservice/WmsCommodity/setCommodityPic
const $axiosUploadCommodityImage = params => axios.get(baseUrl + '/WmsCommodity/setCommodityPic', {params});
//删除上传的商品图片
const $axiosDeleteCommodityImage = params => axios.get(baseUrl + '/WmsCommodity/deleteCommodityPic', {params});

// 删除商品 /jzworkerapiservice/WmsCommodity/deleteCommodity
const $axiosDeleteCommodity = params => axios.get(baseUrl + '/WmsCommodity/deleteCommodity', {params});
// 下架商品 /jzworkerapiservice/WmsCommodity/disableCommodity
const $axiosDisableCommodity = params => axios.get(baseUrl + '/WmsCommodity/disableCommodity', {params});
//新增商品  /jzworkerapiservice/WmsCommodity/addCommodity
const $axiosAddCommodity = params => axios.post(baseUrl + '/WmsCommodity/addCommodity', params);

//取消商品对加盟商的可见
const $axiosDeleteOpen2Fra= params => axios.get(baseUrl + '/WmsCommodity/deleteSkuOpenToFranchisee', {params});
//设置商品对加盟商的可见和价格
const $axiosSetSkuOpenToFranchiseeAndPrice= params => axios.post(baseUrl + '/WmsCommodity/setSkuOpenToFranchiseeAndPrice', params);

// 查询服务站下给定skuId可用的sn码 /jzworkerapiservice/WmsCommodity/getAvailableSnBySkuId
const $axiosGetAvaiableSnCode = async params => await axios.get(baseUrl + '/WmsCommodity/getAvailableSnBySkuId', {params});
// 查询商品下的sku  /jzworkerapiservice/WmsCommodity/getCommoditySku
const $axiosGetCommoditySku = params => axios.get(baseUrl + '/WmsCommodity/getCommoditySku', {params});
//  查询供应商列表 /jzworkerapiservice/wmsPurchase/supplierList
const $axiosSupplierList = params => axios.get(baseUrl + '/wmsPurchase/supplierList', {params});
//启用供应商 /jzworkerapiservice/wmsPurchase/ableSupplier
const $axiosAbleSupplier = params => axios.get(baseUrl + '/wmsPurchase/ableSupplier', {params});
//停用供应商  /jzworkerapiservice/wmsPurchase/disableSupplier
const $axiosDisableSupplier = params => axios.get(baseUrl + '/wmsPurchase/disableSupplier', {params});
//添加供应商  /jzworkerapiservice/wmsPurchase/addNewSupply
const $axiosAddNewSupply = params => axios.post(baseUrl + '/wmsPurchase/addNewSupply', params);
//修改供应商  /jzworkerapiservice/wmsPurchase/modifySupplier
const $axiosModifySupplier = params => axios.post(baseUrl + '/wmsPurchase/modifySupplier', params);
//完善商品SKU信息  /jzworkerapiservice/WmsCommodity/completeCommoditySKU
const $axiosCompleteCommoditySKU = params => axios.post(baseUrl + '/WmsCommodity/completeCommoditySKU', params);
//货品申请单列表  /jzworkerapiservice/wmsPurchase/GoodsApplicationList
const $axiosGoodsApplicationList = params => axios.get(baseUrl + '/wmsPurchase/GoodsApplicationList', {params});
//删除货品申请单  /jzworkerapiservice/wmsPurchase/deleteGoodsApplication
const $axiosGoodsDeleteGoodsApplication = params => axios.get(baseUrl + '/wmsPurchase/deleteGoodsApplication', {params});
//审核货品申请单  /jzworkerapiservice/wmsPurchase/auditGoodsApplication
const $axiosGoodsAuditGoodsApplication = params => axios.get(baseUrl + '/wmsPurchase/auditGoodsApplication', {params});
//创建货品申请单  /jzworkerapiservice/wmsPurchase/createNewGoodsApplication
const $axiosCreateNewGoodsApplication = params => axios.post(baseUrl + '/wmsPurchase/createNewGoodsApplication', params);

/************************start 盘库相关的api*****************/
//1.发起盘库 将仓库置为盘库中状态
//2.站长或者仓库管理人员 领取盘库任务
//3.将盘库的库存结果输入
//4.完成盘库
//发起盘库
const $axiosComparStock = params => axios.post(baseUrl + '/comparStock/launchHouseCompar', params);
//领取盘库任务
const $axiosComparStart = params => axios.get(baseUrl + '/comparStock/startComparStock', {params});

//获取盘点批次
const $axiosComparPageList = params => axios.get(baseUrl + '/comparStock/getPageList', {params});

//获取指定仓库下的库存---待输入的库存记录
const $axiosComparStockList = params => axios.get(baseUrl + '/comparStock/getComparStockList', {params});

const $axiosComparStockPageList = params => axios.get(baseUrl + '/comparStock//getComparStockPage', {params}); //分页

//提交盘库后的库存结果
const $axiosHandleComparStock = params => axios.post(baseUrl + '/comparStock/handleComparStock', params);

//完成盘库
const $axiosComplateComparStock = params => axios.post(baseUrl + '/comparStock/complateComparStock', params);

/************************end 盘库相关的api*****************/
//转出申请  /jzworkerapiservice/wmsStockOrder/transferStock
const $axioswmsStockOrdertransferStock = params => axios.post(baseUrl + '/wmsStockOrder/transferStock', params);
//采购单列表  /jzworkerapiservice/wmsPurchase/purchaseOrderList
const $axioswmsPurchasepurchaseOrderList = params => axios.get(baseUrl + '/wmsPurchase/purchaseOrderList', {params});
//审核采购单  /jzworkerapiservice/wmsPurchase/auditPurchaseOrder
const $axioswmsPurchaseauditPurchaseOrdert = params => axios.get(baseUrl + '/wmsPurchase/auditPurchaseOrder', {params});
//根据采购单查询待入仓信息  /jzworkerapiservice/wmsPurchase/querySkuAndHouseInfo
const $axioswmsPurchasequerySkuAndHouseInfo = params => axios.get(baseUrl + '/wmsPurchase/querySkuAndHouseInfo', {params});
//发起采购单入库  /jzworkerapiservice/wmsPurchase/procurementAndWarehousing
const $axioswmsPurchaseprocurementAndWarehousing = params => axios.post(baseUrl + '/wmsPurchase/procurementAndWarehousing', params);
//预创建采购单  /jzworkerapiservice/wmsPurchase/preCreateNewPurchaseOrder
const $axioswmsPurchasepreCreateNewPurchaseOrder = params => axios.post(baseUrl + '/wmsPurchase/preCreateNewPurchaseOrder', params);
//预创建采购单  /jzworkerapiservice/wmsPurchase/finishPurchaseOrderSkuPrice
const $axioswmsPurchasefinishPurchaseOrderSkuPrice = params => axios.post(baseUrl + '/wmsPurchase/finishPurchaseOrderSkuPrice', params);
//订单列表  /jzworkerapiservice/wmsOrder/getOrderList
const $axioswmsOrdergetOrderList = params => axios.post(baseUrl + '/wmsOrder/getOrderList', params);
//下单  /jzworkerapiservice/wmsOrder/placeOrder
const $axioswmsOrderplaceOrder = params => axios.post(baseUrl + '/wmsOrder/placeOrder', params);
//批量重买
const $asyncBatchRebuy =  params =>  axios.post(baseUrl + '/wmsOrder/reBuy', params);
//录入物流单号
const $asyncupdateLogisticsNo =  params =>  axios.get(baseUrl + '/wmsOrder/updateLogisticsNo', {params});

//支付订单  /jzworkerapiservice/wmsOrder/payOrder
const $axioswmsOrderpayOrder = params => axios.get(baseUrl + '/wmsOrder/payOrder', {params});
//取消订单  /jzworkerapiservice/wmsOrder/cancelOrder
const $axioswmsOrdercancelOrder = params => axios.get(baseUrl + '/wmsOrder/cancelOrder', {params});
//查看订单详情  /jzworkerapiservice/wmsOrder/getOrderInfo
const $axioswmsOrdergetOrderInfo = params => axios.get(baseUrl + '/wmsOrder/getOrderInfo', {params});
// 订单导出
const $axioswmsOrderExport = params => axios.get(baseUrl + '/wmsOrder/listExport', {params});
const $axioswxOrderRefund = params => axios.post(baseUrl + '/wx/order/audit', params);
//根据申请id查询货品申请单商品详情  /jzworkerapiservice/wmsPurchase/goodsApplicationDetail
const $axiosWmsPurchaseGoodsApplicationDetailo = params => axios.get(baseUrl + '/wmsPurchase/goodsApplicationDetail', {params});
//加盟商物料订单退款
const $axiosWmsjmsOrderRefund = params => axios.post(baseUrl + '/wmsOrder/jmsOrderRefund', params);

/*************************************start 租赁相关api******************************* */
//租赁列表
const $axiosOrderLeaseList = params => axios.post(baseUrl + '/wmsOrderLease/getOrderLeaseList', params);
//租赁明细
const $axiosOrderLeaseDetail = params => axios.get(baseUrl + '/wmsOrderLease/getOrderLeaseDetail', {params});
//租赁归还
const $axiosOrderLeaseReturn = params => axios.post(baseUrl + '/wmsOrderLease/orderLeaseReturn', params);
/************************************* end 租赁相关api******************************* */

// /jzworkerapiservice/wmsAutoDis/getPackageTool
//工具包
const $axiosGetPackageTool = params => axios.get(baseUrl + '/wmsAutoDis/getPackageTool', {params});
const $axiossetPackageTool = params => axios.post(baseUrl + '/wmsAutoDis/setPackageTool', params);
const $axiosdeletePackageTool = params => axios.get(baseUrl + '/wmsAutoDis/deletePackageTool', {params});
const $axiosAuditPackageTool = params => axios.get(baseUrl + '/wmsAutoDis/auditPackageTool', {params});
const $axiosToolKitList  = params => axios.get(baseUrl + '/wmsAutoDis/toolKitList',{
   params,
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: "repeat" });
  },
})
const $axiosCancelToolKit = params => axios.get(baseUrl + '/wmsAutoDis/cancelToolKit', {params});
const $axiosAutodisgenerate = params => axios.get(baseUrl + '/wmsAutoDis/generate', {params});

const $ajaxSysCityGetPageList = params => axios.get(baseUrl+'/sysCity/getPageList', { params });
const $ajaxSysCityAddCity = params => axios.post(baseUrl + '/sysCity/addCity', params);
const $ajaxImportYyCheckIn = params => axios.post(baseUrl + '/crmSubDataImport/importYyCheckIn', params);
const $ajaxImportEvaluation = params => axios.post(baseUrl + '/crmSubDataImport/importYyEvaluation', params);
const $ajaxGetRuleConfig = params => axios.get(baseUrl + '/crmWorkerGoal/getRuleConfig', {params});
const $ajaxGetWorkerGoal = params => axios.post(baseUrl + '/crmWorkerGoal/getWorkerGoal', params);
const $ajaxStopOrStartRuleConfig = params => axios.get(baseUrl + '/crmWorkerGoal/stopOrStartRuleConfig', {params});
const $ajaxUpdateRuleConfig = params => axios.post(baseUrl + '/crmWorkerGoal/updateRuleConfig', params);

const $ajaxgetTelecomCardPageList = params => axios.post(baseUrl + '/telecomCard/getPageList', params);
const $ajaxgetResultInfo = params => axios.get(baseUrl + '/telecomCard/getResultInfo', {params});

// 电信卡订单导出
const $ajaxgetTelecomCardPageListExport = params => axios.post(baseUrl +'/telecomCard/getPageList', params, {
  responseType: 'blob',
}).then((response) => {
  let str = response.headers["content-disposition"]
    .split(";")[1]
    .split("=")[1];
  let fileName = decodeURI(str);
  if (window.navigator.msSaveOrOpenBlob) {
    // 兼容 IE 10
    navigator.msSaveBlob(new Blob([response.data]), fileName);
  } else {
    let url = window.URL.createObjectURL(new Blob([response.data]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", `${fileName}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  //   this.importFileLoading = false;
})
  .catch((response) => {
    console.log(response);
    //   let fileName = '导出了.xlsx';
    let fileName = Date.parse(new Date()) + randomNum(1, 1200) + '.xlsx';
    console.log(fileName);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    //   this.importFileLoading = false;
  });



export default {
  addFile,
  $ajaxAddFile,
  $axiosGetWmshousePageList,
  $axiosWmshouseAdd,
  $axiosUpdateStatus,
  $axiosWmshouseUpdate,
  $axiosgetAllHouse,
  $axiosGeCurrentLoginUserHouse,
  $axiosWmsHouseStockStockList,
  $axiosWmsHouseStockstockSubInfo,
  $axiosWmsHouseStockgetStockLogPage,
  $axiosWmsHouseStockgetStockReport,
  $axiosGetAllStationList,
  $axiosCityStationGetAll,
  $axiosgetallCity,
  $axiosGetStockOrderList,
  $axiosGetStockOrderInfo,
  $axiosOperateStockOrder,
  $axiosCategoryTree,
  $axiosAddNewCategory,
  $axiosDeleteCategory,
  $axiosUpdateCategory,
  $axiosBrandList,
  $axiosAbleBrand,
  $axiosDisabledBrand,
  $axiosAddNewBrand,
  $axiosModifyBrand,
  $axiosPropertyList,
  $axiosDeleteProperty,
  $axiosAddNewProperties,
  $axiosUpdateProperty,
  $axiosPropertyBindRelationByCategoryId,
  $axiosBindProperty,
  $axiosDeletePropertyBindRelation,
  $axiosModifyPropertyBind,
  $axiosCommodityList,
  $axiosAbleCommodity,
  $axiosDeleteCommodity,
  $axiosDisableCommodity,
  $axiosAddCommodity,
  $axiosGetCommoditySku,
  $axiosSupplierList,
  $axiosAbleSupplier,
  $axiosDisableSupplier,
  $axiosAddNewSupply,
  $axiosModifySupplier,
  $axiosCompleteCommoditySKU,
  $axiosGoodsApplicationList,
  $axiosGoodsDeleteGoodsApplication,
  $axiosGoodsAuditGoodsApplication,
  $axiosCreateNewGoodsApplication,
  $axiosComparStock,
  $axiosComparPageList,
  $axiosComparStockList,
  $axiosComparStart,
  $axiosHandleComparStock,
  $axiosComplateComparStock,
  $axiosComparStockPageList,
  $axioswmsStockOrdertransferStock,
  $axioswmsPurchasepurchaseOrderList,
  $axioswmsPurchaseauditPurchaseOrdert,
  $axioswmsPurchasequerySkuAndHouseInfo,
  $axioswmsPurchaseprocurementAndWarehousing,
  $axioswmsPurchasepreCreateNewPurchaseOrder,
  $axioswmsPurchasefinishPurchaseOrderSkuPrice,
  $axiosOrderLeaseList,
  $axiosOrderLeaseDetail,
  $axiosOrderLeaseReturn,
  $axioswmsOrdergetOrderList,
  $axioswmsOrderplaceOrder,
  $asyncBatchRebuy,
  $axioswmsOrderpayOrder,
  $axioswmsOrdercancelOrder,
  $axioswmsOrdergetOrderInfo,
  $axiosWmsPurchaseGoodsApplicationDetailo,
  $axiosWmsjmsOrderRefund,
  $axioswxOrderRefund,
  $axiosGetAvaiableSnCode,
  $axioswmsOrderExport,
  $axiosUploadCommodityImage,
  $axiosDeleteCommodityImage,
  $axiosGetPackageTool,
  $axiossetPackageTool,
  $axiosdeletePackageTool,
  $axiosAuditPackageTool,
  $axiosToolKitList,
  $axiosCancelToolKit,
  $axiosAutodisgenerate,
  $ajaxSysCityGetPageList,
  $ajaxSysCityAddCity,
  $ajaxImportYyCheckIn,
  $ajaxImportEvaluation,
  $ajaxGetRuleConfig,
  $ajaxGetWorkerGoal,
  $ajaxStopOrStartRuleConfig,
  $ajaxUpdateRuleConfig,
  $ajaxgetTelecomCardPageList,
  $ajaxgetResultInfo,
  $asyncupdateLogisticsNo,
  $axiosDeleteOpen2Fra,
  $axiosSetSkuOpenToFranchiseeAndPrice,
  $ajaxgetTelecomCardPageListExport
}
